import * as mobxReact from 'mobx-react';
import * as React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import DefaultButton from '../../../global/default-button/default-button';
import { ManageEventNavigation } from '../shared/navigation/navigation';
import { EditWebsiteViewModel } from './edit-website.viewmodel';
import { WebsiteFormBody } from './website-form-body/website-form-body';
import './edit-website.presentation.scss';
import OptionsButton from '../../../global/options-button/options-button';
import { DefaultCloseModalButton } from '../../../global/modal/common/common-close-modal-buttons';
import UploadButton, { FILE_TYPE } from '../shared/upload-button';
import { CommonModal } from '../../../global/modal/common/common-modal';
import { hasPermission } from '../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../api/roles.dao';
import {
    DOWNLOAD_CONFIGURATION_TEXT,
    UPDATE_WEBSITE_TEXT,
    UPLOAD_CONFIGURATION_BUTTON_TEXT,
    UPLOAD_CONFIGURATION_LABEL_TEXT,

} from './edit-website.texts';
import { LOADING, MORE_BUTTON_TEXT } from '../../../../constants/common-labels.constants';

const EditWebsitePresentation = injectIntl(mobxReact.observer((props: { vm: EditWebsiteViewModel; intl: IntlShape }) => {
    const vm = props.vm;
    const moreOptions = [{
        label: props.intl.formatMessage(DOWNLOAD_CONFIGURATION_TEXT),
        action: vm.downloadConfigurationJSON
    }];

    return (
        <div>
            <section className='horizontal-row with-border-bottom event-tabs website-tab'>
                <ManageEventNavigation/>
                {hasPermission(Permission.PASSPORT_TAB) &&
                    <div className='horizontal-row__align-to-row-end'>
                        <div className='buttons-block'>
                            <DefaultButton
                                modifier={['fat', 'confirm-safe']}
                                text={<FormattedMessage {...UPLOAD_CONFIGURATION_BUTTON_TEXT} />}
                                onClick={() => vm.setUploadConfigurationModalOpen(true)}
                            />
                            <OptionsButton
                                modifier={['fat', 'options']}
                                label={props.intl.formatMessage(MORE_BUTTON_TEXT)}
                                options={moreOptions}
                            />
                        </div>
                    </div>
                }
            </section>
            <section className='website-container'>
                <form
                    className='oe-form w-100 max-w-65em'
                    onSubmit={vm.updateWebsite}
                    noValidate
                    onChange={() => vm.setSaveError('')}
                >
                    {vm.isLoading()
                        ? <FormattedMessage
                            {...LOADING}
                            values={{
                                suffix: ''
                            }}
                        />
                        : <>
                            <WebsiteFormBody vm={vm.getFormFields()}/>
                            {hasPermission(Permission.PASSPORT_TAB) &&
                                <div className='oe-form__footer m-top-15px'>
                                    <DefaultButton
                                        type='submit'
                                        text={<FormattedMessage {...UPDATE_WEBSITE_TEXT}/>}
                                        modifier='fat'
                                    />
                                    {vm.isSaving() &&
                                    <span className='form-saving-indicator p-left-8px'>
                                    <FormattedMessage
                                        id='oe.website.isUpdatingWait'
                                        defaultMessage='Website is being updated, please wait{suffix}'
                                        description='Loading message text'
                                        values={{
                                            suffix: '...'
                                        }}
                                    />
                                </span>}
                                    {vm.getSaveError() &&
                                    <span className='oe-form__error p-left-8px'>{vm.getSaveError()}</span>}
                                </div>
                            }
                        </>
                    }
                </form>
            </section>
            <CommonModal
                title={props.intl.formatMessage(UPLOAD_CONFIGURATION_LABEL_TEXT)}
                isOpen={vm.getUploadConfigurationModalOpen()}
                onRequestClose={() => {
                    vm.setUploadConfigurationModalOpen(false);
                }}
                footer={(
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultButton
                            text={<FormattedMessage {...UPLOAD_CONFIGURATION_BUTTON_TEXT}/>}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => vm.uploadConfigurationJSON()}
                            disabled={!vm.getConfigurationJSONFileName()}
                        />
                        <DefaultCloseModalButton />
                    </div>
                )}>
                <div className='attendees-list__csv-modal-form'>
                    <UploadButton
                        fileName={vm.getConfigurationJSONFileName()}
                        onChange={vm.setConfigurationJSONFile}
                        uploadedFileType={FILE_TYPE.JSON}
                        className='attendees-list-option attendees-list-option__in-modal'
                    />
                </div>
            </CommonModal>
        </div>
    );
}));

const EditWebsiteContainer =
    (props: { vm: EditWebsiteViewModel }) => {
        return <EditWebsitePresentation vm={props.vm}/>;
    }
;

export { EditWebsiteContainer as EditWebsite, EditWebsitePresentation };